import React from 'react';
import {IntlProvider} from 'react-intl';
import {Provider} from "react-redux";
import configureStore from './store';
import {PersistGate} from "redux-persist/integration/react";
import ReactDOM from 'react-dom';
import messages from './messages/en';
import EQ from "./EQ";
import {flattenMessages} from "./assets-static/scripts/utils";
import {BrowserRouter, Route, Switch} from "react-router-dom";

import 'intl'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'

const {store, persistor} = configureStore()
ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <IntlProvider locale="en" key="en" messages={flattenMessages(messages)}>
                <BrowserRouter>
                    <Switch>
                        <Route path="/i821premium/interactions/eq">
                            <EQ/>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);
